import {
    connect
} from 'react-redux'
import Fitting1ExportComponent from '../components/Fitting1ExportComponent.jsx';
import {
    exportFittingAppData
} from '../actions';

const mapStateToProps = (state) => ({
    orderId: state.getIn(['fitting1Reducer', 'orderId']),
    downloadUrl: state.getIn(['fitting1Reducer', 'downloadUrl']),
    alertStyle: state.getIn(['fitting1Reducer', 'alertStyle']),
    alertMessage: state.getIn(['fitting1Reducer', 'alertMessage']),
})

const mapDispatchToProps = (dispatch) => ({
    exportData: (payload) => {
        dispatch(exportFittingAppData(payload));
    },
})

const Fitting1ExportContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Fitting1ExportComponent)

export default Fitting1ExportContainer;


// WEBPACK FOOTER //
// ./src/containers/Fitting1ExportContainer.jsx